import { render, staticRenderFns } from "./ManterComarca.vue?vue&type=template&id=e567af72&scoped=true&"
import script from "./ManterComarca.vue?vue&type=script&lang=js&"
export * from "./ManterComarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e567af72",
  null
  
)

export default component.exports